import { response_t, saga_act } from 'src/types'
import { group_t } from 'src/types/http/group.types'
import { do_request } from './base.http'

/**
 * Group
 */
export async function http_group({ args, type }: saga_act): Promise<response_t<group_t>> {
  let value = await do_request<group_t>({
    path: '/get-group',
    args: args,
    saga_type: type,
  })

  return value
}
